import { render, staticRenderFns } from "./Medicines.vue?vue&type=template&id=21e1510c"
import script from "./Medicines.vue?vue&type=script&lang=js"
export * from "./Medicines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports